export default {"src":"/_next/static/media/icon_nav_dd_provide_storage_on.b37ce4b1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};